import { CircularCardVariant } from 'components/molecules/card/circular'
import type { CircularCardProps } from 'components/molecules/card/circular'
import { DefaultCardVariant } from 'components/molecules/card/default'
import type { DefaultCardProps } from 'components/molecules/card/default'
import { ListCardVariant } from 'components/molecules/card/list'
import type { ListCardProps } from 'components/molecules/card/list'
import type { CardProps } from './types'

import { ECommissionVariant } from 'components/organisms/Commission'

const cardVariants = {
  [ECommissionVariant.LIST]: ListCardVariant,
  [ECommissionVariant.DEFAULT]: DefaultCardVariant,
  [ECommissionVariant.CIRCULAR]: CircularCardVariant,
} as const

export const Card = ({
  variant = ECommissionVariant.DEFAULT,
  ...props
}: CardProps) => {
  const CardComponent =
    cardVariants[variant] || cardVariants[ECommissionVariant.DEFAULT]

  return (
    <CardComponent
      {...(props as DefaultCardProps & ListCardProps & CircularCardProps)}
    />
  )
}
